import * as React from 'react'
import { IFilter, ISeries, IIncomingContributionsResponse, roundNumber, IVisualizationState, IPeerGroupTabsProps } from '../../lib/http'
import * as ReactHighcharts from 'react-highcharts'
import { Alert, Panel } from 'react-bootstrap'
import PanelGraph from 'app/components/tabs/PanelGraph'

export class PerOneMillion extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    data: [],
    categories: [],
    filters: { assetLevel: 0 },
    loading: false,
    average: [],
    title: '',
    series: [],
    plotLineNumber: 0,
  }

  componentDidMount() {
    this.setState({ data: this.props.data }, () => this.loadSeries(this.props.filters))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    data.reverse()

    const currentSet = data.find(dataPoint => dataPoint.filterId === filters.assetLevel)

    const filterOutAllFoundations = data.filter(dataPoint => dataPoint.filterId > 0)

    const categories = filterOutAllFoundations.map(dataPoint => dataPoint['InvExp_T_V3_ColName'])

    const selectedColor = "#0070C0"
    const nonSelectedColor = "#D9E1F2"
    const plotLineNumber = currentSet ? currentSet['InvExp_N_V1_InvExpAvg'] : ''

    const seriesData = filterOutAllFoundations.map(dataPoint => dataPoint.filterId === filters.assetLevel ?
      { y: dataPoint.InvExp_N_V2_InvExpPerMil, color: selectedColor, filterId: dataPoint.filterId }
      : { y: dataPoint.InvExp_N_V2_InvExpPerMil, color: nonSelectedColor, filterId: dataPoint.filterId })

    const averageData = filterOutAllFoundations.map((dataPoint, index) => {
      return index === 0 ?
        { y: dataPoint.InvExp_N_V1_InvExpAvg * 100.0, dataLabels: { enabled: true, format: 'Average: ${y:,.0f}' } }
        : dataPoint.InvExp_N_V1_InvExpAvg * 100.0
    })

    const title = currentSet ? currentSet['InvExp_T_V1_Vis1Title'] : ''

    const series = [
      { color: '#D9E1F2', name: 'Per Million Dollars', data: seriesData, events: { click: (e) => this.updateFilter(e) }, borderWidth: 1, borderColor: '#a1a1a1' },
      { color: '#a1a1a1', name: 'Average', data: averageData, type: 'line', dashStyle: 'ShortDash', lineWidth: 3, marker: { enabled: false }, }]

    this.setState({ categories, title, loading: false, series, plotLineNumber })
  }

  updateFilter(e) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(e.point.filterId)
    }
  }


  static getPublicIndexConfig(series, categories, plotLineNumber, title) {
    return {
      chart: { type: 'bar' },
      title: {
        text: title
      },
      xAxis: {
        categories
      },
      yAxis: {
        visible: false,
        opposite: false,
        title: '',
        labels: {
          format: '${value}mm',
        },
        plotLines: [{
          color: '#a1a1a1',
          dashStyle: 'ShortDash',
          value: plotLineNumber,
          zIndex: 2,
          width: '3'
        }],
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '${y:,.0f}',
          }
        },
        line: {

        }
      },
      legend: { enabled: false },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { loading, categories, series, plotLineNumber } = this.state
    const title = 'Per Million Dollars of Assets'
    return (
      <PanelGraph title="" loading={loading} chartConfig={PerOneMillion.getPublicIndexConfig(series, categories, plotLineNumber, title)} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Expenses/PerOneMillion/index.tsx